import React, { Fragment, useState } from "react";
import InputFieldsEmailTextPassword from "../common/InputFieldsEmailTextPassword";
import Select from "react-select";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import InputFieldNumber from "../common/InputFieldNumber";
import TextAreaField from "../common/TextAreaField";
import Toggle from "../common/Toggle";
import LinkBorderCommonButton from "../common/LinkBorderCommonButton";
import { clientDashboard } from "../common/allLinks";

const projectDurationOptions = [{ value: "3 Months", label: "3 Months" }];
const urgencyOptions = [{ value: "This Week", label: "This Week" }];
const billingTypeOption = [{ value: "Monthly", label: "Monthly" }];

const dummyData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export default function ClientDashboardAddNewRequirementAddProjectDetails({
  handleOnSelect,
}) {
  const [values, setValues] = useState({
    requirementTitle: "",
    engagementType: "Resource Augmentation",
    projectType: "Time and Material",
    noOfResources: "",
    projectLocation: "",
    description: "",
    projectDuration: "",
    urgency: "",
    billingRate: "",
    billingType: "",
    coordinatorName: "",
    coordinatorDesignation: "",
    coordinatorEmail: "",
    coordinatorPhoneNumber: "",
    isRemote: false,
  });

  const [activeIndex, setActiveIndex] = useState(0);

  /*===========================================
                handleOnChange
===========================================*/
  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    // console.log(values);
  };

  const handleOnChangeNumber = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.validity.valid ? e.target.value : "",
    });
    // console.log(values);
  };

  const handleChangeProjectDuration = (selectedOption) => {
    setValues({ ...values, projectDuration: selectedOption });
  };

  const handleChangeUrgency = (selectedOption) => {
    setValues({ ...values, urgency: selectedOption });
  };

  const handleChangeBillingType = (selectedOption) => {
    setValues({ ...values, billingType: selectedOption });
  };

  const handleOnSelectResources = (index) => {
    setActiveIndex(index);
    setValues({ ...values, noOfResources: index + 1 });
  };
  const handleOnChangeToggle = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.checked,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(values);
    handleOnSelect(1);
  };

  /**==========================================================================
   * 
                       *          return
   * 
  ============================================================================ */
  return (
    <div className="client-dashboard-add-new-requirement-project-detaild-main-div">
      {/* Requirement Title && Project Duration */}
      <div className="row mx-0 align-items-start flex-md-nowrap">
        <div className="col-12 col-md-6 ">
          <InputFieldsEmailTextPassword
            type="text"
            name="requirementTitle"
            value={values.requirementTitle}
            placeholder="For ex: Need 3 react resources, remote project."
            onChange={handleOnChange}
            label="Requirement Title"
          />
        </div>
        <div className="col-12 col-md-6">
          <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
            Project Duration
          </p>
          <div className="react-select-client-dashboard-add-new-requirement">
            <Select
              className="react-select-container react-select-container--client-dashboard-add-new-requirement"
              classNamePrefix="react-select-elements"
              isSearchable={false}
              options={projectDurationOptions}
              value={values.projectDuration}
              onChange={handleChangeProjectDuration}
              placeholder="Select"
            />
          </div>
        </div>
      </div>

      {/* Engagement Type && Urgency */}
      <div className="row mx-0 align-items-start flex-md-nowrap pt-25">
        <div className="col-12 col-md-6 ">
          <InputFieldsEmailTextPassword
            type="text"
            name="engagementType"
            value={values.engagementType}
            placeholder="Resource Augmentation"
            onChange={handleOnChange}
            label="Engagement Type"
            isReadOnly={true}
          />
        </div>
        <div className="col-12 col-md-6">
          <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
            Urgency
          </p>
          <div className="react-select-client-dashboard-add-new-requirement">
            <Select
              className="react-select-container react-select-container--client-dashboard-add-new-requirement"
              classNamePrefix="react-select-elements"
              isSearchable={false}
              options={urgencyOptions}
              value={values.urgency}
              onChange={handleChangeUrgency}
              placeholder="Select"
            />
          </div>
        </div>
      </div>

      {/* Project Type && Urgency */}
      <div className="row mx-0 align-items-start flex-md-nowrap pt-25">
        <div className="col-12 col-md-6 ">
          <InputFieldsEmailTextPassword
            type="text"
            name="projectType"
            value={values.projectType}
            placeholder="Time and Material"
            onChange={handleOnChange}
            label="Project Type"
            isReadOnly={true}
          />
        </div>
        <div className="col-12 col-md-6">
          <InputFieldNumber
            label={"Billing Rate ($/Hr/Resource)"}
            placeholder="14 $"
            name="billingRate"
            value={values.billingRate}
            onChange={handleOnChangeNumber}
          />
        </div>
      </div>
      {/*No of Resources Required  && Project Co-ordinator Details*/}
      <div className="row mx-0 align-items-start flex-md-nowrap pt-25">
        <div className="col-12 col-md-6 ">
          <div>
            <h4 className="font-14-NunitoSans-600">No of Resources Required</h4>
            <div className="pt-25 client-dashboard-add-new-requirement-resorces-div">
              {dummyData.map((data, key) => (
                <Fragment key={key}>
                  <button
                    className="client-dashboard-add-new-requirement-resorces-btn"
                    onClick={() => handleOnSelectResources(key)}
                  >
                    {key === dummyData.length - 1 ? (
                      <>
                        {activeIndex === dummyData.length - 1 ? (
                          <img
                            src={"/img/desktop/icons/white-two-users-icon.svg"}
                            alt="resources"
                            className="client-dashboard-add-new-requirement-resorces-two-user-icon"
                          />
                        ) : (
                          <img
                            src={"/img/desktop/icons/gray-two-users-icon.svg"}
                            alt="resources"
                            className="client-dashboard-add-new-requirement-resorces-two-user-icon-gray"
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {key <= activeIndex ? (
                          <img
                            src={"/img/desktop/icons/white-profile-icon.svg"}
                            alt="resources"
                          />
                        ) : (
                          <img
                            src={"/img/desktop/icons/gray-profile-icon.svg"}
                            alt="resources"
                          />
                        )}
                      </>
                    )}
                  </button>
                </Fragment>
              ))}
              <h5 className="font-24-NunitoSans-600 client-add-project-details-project-resource-text">
                {activeIndex + 1 === 15 ? "15 +" : activeIndex + 1}
                <span className="font-14-NunitoSans-600 color-white-66">
                  {" "}
                  Resources
                </span>
              </h5>
            </div>
          </div>
          <div className="mt-50">
            <h4 className="font-14-NunitoSans-600">Project Location</h4>
            <div className=" client-dashboard-add-new-requirement-toggle-div">
              <Toggle
                text1={"Remote"}
                text2={"Onsite"}
                defaultChecked={values.isRemote}
                onChange={handleOnChangeToggle}
                name={"isRemote"}
                textClassName="font-14-NunitoSans-600"
              />
              {values.isRemote && (
                <InputFieldsEmailTextPassword
                  containerClassName="client-dashboard-add-new-requirement-project-location ml-30"
                  type="text"
                  name="projectLocation"
                  value={values.projectLocation}
                  placeholder="For Ex. Mumbai, India"
                  onChange={handleOnChange}
                  // label="Coordinator Name"
                />
              )}
            </div>
          </div>
          <TextAreaField
            containerClassName="mt-50"
            label="Description"
            placeholder="For ex, Additional Details"
            onChange={handleOnChange}
            name="description"
            value={values.description}
          />
        </div>
        <div className="col-12 col-md-6">
          <div>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Billing Type
            </p>
            <div className="react-select-client-dashboard-add-new-requirement">
              <Select
                className="react-select-container react-select-container--client-dashboard-add-new-requirement"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={billingTypeOption}
                value={values.billingType}
                onChange={handleChangeBillingType}
                placeholder="Select"
              />
            </div>
          </div>
          <h5 className="font-36-nunito-semibold client-add-project-details-project-coordinator-text">
            Project Co-ordinator Details{" "}
          </h5>
          <InputFieldsEmailTextPassword
            type="text"
            name="coordinatorName"
            value={values.coordinatorName}
            placeholder="Ex. Jessie"
            onChange={handleOnChange}
            label="Coordinator Name"
          />
          <InputFieldsEmailTextPassword
            type="text"
            name="coordinatorDesignation"
            value={values.coordinatorDesignation}
            placeholder="Ex. Tech Lead"
            onChange={handleOnChange}
            label="Coordinator Designation"
          />
          <InputFieldsEmailTextPassword
            type="email"
            name="coordinatorEmail"
            value={values.coordinatorEmail}
            placeholder="Ex. Mail@address.com"
            onChange={handleOnChange}
            label="Email Address"
          />
          <InputFieldNumber
            label={"Phone Number"}
            placeholder="Ex: 91 XXXXXX"
            name="coordinatorPhoneNumber"
            value={values.coordinatorPhoneNumber}
            onChange={handleOnChangeNumber}
          />
        </div>
      </div>
      <div className="text-center mt-50 mobile-d-flex">
        <LinkBorderCommonButton
          linkPath={clientDashboard}
          linkText="Save &amp; Exit"
          extraClassName="login-btn-link--preview mr-30"
        />
        <ButtonCommonComponent
          extraClassName="login-btn--px-45"
          text="Save &amp; Next"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}
